import React from 'react';
import './ImageUpload.css';

const ImageUpload = ({ onComplete }) => {
  const handleImageUpload = (event) => {
    const files = Array.from(event.target.files);
    const imageUrls = files.map(file => URL.createObjectURL(file));
    onComplete(imageUrls);
  };

  return (
    <div className="image-upload-container">
      <div className="upload-box">
        <label className="upload-label">
          <input
            type="file"
            multiple
            accept="image/*"
            onChange={handleImageUpload}
            className="file-input"
          />
          <span>Click to select images</span>
        </label>
      </div>
    </div>
  );
};

export default ImageUpload;